import { styled } from 'styled-components';
export const Wrapper = styled.div`
  width: 364px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgb(75, 68, 76);
  background-color: #161639;

  @media (max-width: 768px) {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 24px);
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-image: ${({ $error }) =>
      $error
        ? 'url(/images/background/ellipse-error.svg)'
        : 'url(/images/background/ellipse-success.svg)'};
    background-repeat: no-repeat;
    z-index: 1;

    @media (max-width: 768px) {
      background-size: contain;
    }
  }
`;

export const BonusBannerWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const BonusBanner = styled.div`
  max-height: 200px;
  background-image: ${({ $banner }) => `url(${$banner})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: #161639;
    z-index: 1;
    background: linear-gradient(180deg, rgba(18, 22, 32, 0.8) 0%, #161639 100%);
  }
`;

export const BonusContent = styled.div`
  padding: 12px 24px;
  padding-bottom: 24px;
  position: relative;
  background-color: #161639;
  top: -1px;
`;

export const BonusStatus = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  border-radius: 4px;
  background: ${({ $error }) => ($error ? '#DA4444' : '#08ad5e')};
  padding: 0px 4px;
  display: inline-block;
  margin-bottom: 32px;
`;

export const BonusInfo = styled.div`
  display: flex;
  padding: 10px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 8px;
  background: rgba(27, 32, 45, 0.4);
  margin-bottom: 32px;
  justify-content: space-between;
`;
